import { map } from 'ramda';
import { format as asTagString } from '~/util/Validation/Tag';
import hasValue from '~/util/hasValue';
import type { KenmerkLookup } from '../../types';

/**
 * Fills empty/null kenmerk tags from their description using the tag formatter.
 * Existing non-empty tags are left unchanged.
 */
const fillEmptyKenmerkTags = (kenmerkLookup: KenmerkLookup): KenmerkLookup =>
  map(
    kenmerken =>
      kenmerken.map(kenmerk =>
        hasValue(kenmerk.tag)
          ? kenmerk
          : { ...kenmerk, tag: asTagString(kenmerk.description) },
      ),
    kenmerkLookup,
  );

export default fillEmptyKenmerkTags;
